export const quiz_fr =  {
  "general": {
    "title": "Les droits de l'enfant à l'hôpital et lors des visites médicales",
    "intro": "Quelles affirmations sont correctes ? Clique dessus ! Attention ! Plusieurs réponses peuvent être correctes !",
    "finishButton": "Vérifier les réponses",
    "nrQuestions": 7,
    "maxPoints": 35,
    "resultTitle": "C'est fait!",
    "resultText": "Tu as répondu correctement à <correctQuestions> de <questions> et tu as donc obtenu <points> de <pointsMax> points.",
    "button_back": "retour",
    "button_forward": "prochaine"
  },
  "questions": [
    {
      "question": "Dois-je toujours être soigné à l'hôpital lorsque je suis malade ?",
      "picture": "",
      "answers": [
        "Oui ! Un hôpital pour enfants est le meilleur endroit pour les enfants malades !",
        "Selon la gravité des symptômes, une consultation chez le médecin peut suffire - l'hôpital n'est pas toujours nécessaire.",
        "Vérifie s’il existe des alternatives à l’hôpital, comme par exemple les soins à domicile pour les enfants et un traitement en hôpital de jour."
      ],
      "correctAnswer": [1,2],
      "point": 5,
      "evaluate": true
    },
    {
      "question": "A l'hôpital, beaucoup de choses sont étranges et inconnues. Qu'est-ce qui peut t'aider à te sentir plus en sécurité ?",
      "picture": "",
      "answers": [
        "Je me fais accompagner par une personne de confiance.",
        "Je demande à ce qu'on m'explique tout en détail.",
        "J'emmène ma peluche préférée avec moi."
      ],
      "correctAnswer": [0,1,2],
      "point": 5,
      "evaluate": true
    },
    {
      "question": "Qui t'aide si tu as peur ou si tu as des questions à l'hôpital ?",
      "picture": "",
      "answers": [
        "Mes parents ou une personne de confiance peuvent presque toujours être à mes côtés, même la nuit ou avant une opération.",
        "C'est normal d'avoir peur. J'en parle. A l'hôpital, tout le monde m'aide à aller mieux.",
        "Hé, je suis déjà grand et je peux tout faire tout seul !"
      ],
      "correctAnswer": [0,1],
      "point": 5,
      "evaluate": true
    },
    {
      "question": "Est-ce que les adultes peuvent toujours décider quel traitement est le meilleur pour toi ?",
      "picture": "",
      "answers": [
        "Non ! J'ai le droit de poser des questions et d'obtenir des explications. Je veux tout comprendre.",
        "Non ! Si je ne veux pas d'un traitement, je le dis. Cela doit être respecté.",
        "Oui ! Les adultes peuvent toujours décider comment je dois être soigné."
      ],
      "correctAnswer": [0,1],
      "point": 5,
      "evaluate": true
    },
    {
      "question": "Dois-tu faire tout ce que les médecins et tes parents te disent de faire ?",
      "picture": "",
      "answers": [
        "Non, mon opinion est importante ! Je dis si quelque chose me met mal à l'aise ou si je ne veux pas quelque chose.",
        "Bien sûr ! Mes parents et les médecins savent évidemment ce qui est le mieux.",
        "Non. Je peux par exemple demander aux adultes de quitter la pièce lorsque je me change."
      ],
      "correctAnswer": [0,2],
      "point": 5,
      "evaluate": true
    },
    {
      "question": "Si tu dois rester longtemps à l'hôpital, restes-tu simplement au lit ?",
      "picture": "",
      "answers": [
        "Bien sûr ! C'est cool !",
        "Non. C’est important que j'aie la possibilité de jouer ou d'apprendre des choses.",
        "Non, lors de longs séjours, l'hôpital veille à ce que je puisse apprendre, par exemple dans une école de l’hôpital."
      ],
      "correctAnswer": [1],
      "point": 5,
      "evaluate": true
    },
    {
      "question": "A l'hôpital, es-tu dans le même service que les adultes ?",
      "picture": "",
      "answers": [
        "Non, les enfants sont soignés dans un hôpital pour enfants ou dans un service de pédiatrie.",
        "Oui, c'est le plus facile.",
        "Non. On veille à ce que les enfants du même âge soient ensemble."
      ],
      "correctAnswer": [0,2],
      "point": 5,
      "evaluate": true
    },
  ]
} 